"use strict";
var Observable_1 = require("../../Observable");
var auditTime_1 = require("../../operator/auditTime");
Observable_1.Observable.prototype.auditTime = auditTime_1.auditTime;
//# sourceMappingURL=auditTime.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/auditTime.js
 ** module id = 329
 ** module chunks = 1
 **/